/* District47 — Rugged Field :: theme behaviors (vanilla, no deps) */
(function () {
  "use strict";

  /* Mobile nav drawer */
  function initMobileNav() {
    var toggle = document.querySelector("[data-nav-toggle]");
    var drawer = document.querySelector("[data-mobile-nav]");
    if (!toggle || !drawer) return;
    var close = drawer.querySelector("[data-nav-close]");
    function open() { drawer.classList.add("is-open"); document.body.style.overflow = "hidden"; }
    function shut() { drawer.classList.remove("is-open"); document.body.style.overflow = ""; }
    toggle.addEventListener("click", open);
    if (close) close.addEventListener("click", shut);
    drawer.addEventListener("click", function (e) { if (e.target === drawer) shut(); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") shut(); });
  }

  /* Quantity steppers */
  function initQty() {
    document.querySelectorAll("[data-qty]").forEach(function (wrap) {
      var input = wrap.querySelector("input");
      if (!input) return;
      wrap.querySelectorAll("[data-qty-step]").forEach(function (btn) {
        btn.addEventListener("click", function () {
          var step = parseInt(btn.getAttribute("data-qty-step"), 10);
          var val = Math.max(1, (parseInt(input.value, 10) || 1) + step);
          input.value = val;
          input.dispatchEvent(new Event("change", { bubbles: true }));
        });
      });
    });
  }

  /* Product gallery thumbnail switching */
  function initGallery() {
    document.querySelectorAll("[data-gallery]").forEach(function (gallery) {
      var main = gallery.querySelector("[data-gallery-main] img");
      if (!main) return;
      gallery.querySelectorAll("[data-gallery-thumb]").forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          var full = thumb.getAttribute("data-full");
          if (full) main.src = full;
          gallery.querySelectorAll("[data-gallery-thumb]").forEach(function (t) {
            t.setAttribute("aria-current", t === thumb ? "true" : "false");
          });
        });
      });
    });
  }

  /* Variant selection -> update price / availability / hidden id */
  function initVariants() {
    document.querySelectorAll("[data-product-form]").forEach(function (form) {
      var data = form.querySelector("[data-variants-json]");
      if (!data) return;
      var variants;
      try { variants = JSON.parse(data.textContent); } catch (e) { return; }
      var idInput = form.querySelector("[data-variant-id]");
      var priceEl = document.querySelector("[data-product-price]");
      var addBtn = form.querySelector("[data-add-btn]");

      function currentOptions() {
        return Array.prototype.map.call(
          form.querySelectorAll("[data-option-index]"),
          function (el) {
            if (el.type === "radio") {
              var checked = form.querySelector('input[name="' + el.name + '"]:checked');
              return checked ? checked.value : null;
            }
            return el.value;
          }
        ).filter(function (v, i, a) { return a.indexOf(v) === i || v !== null; });
      }

      function match() {
        var selected = [];
        form.querySelectorAll("[data-option-index]").forEach(function (el) {
          var idx = parseInt(el.getAttribute("data-option-index"), 10);
          if (el.type === "radio") {
            var checked = form.querySelector('input[name="' + el.name + '"]:checked');
            if (checked) selected[idx] = checked.value;
          } else {
            selected[idx] = el.value;
          }
        });
        return variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        });
      }

      function update() {
        var v = match();
        if (!v) return;
        if (idInput) idInput.value = v.id;
        if (priceEl && v.price != null) priceEl.textContent = formatMoney(v.price);
        if (addBtn) {
          addBtn.disabled = !v.available;
          addBtn.textContent = v.available ? addBtn.getAttribute("data-add-label") || "Add to cart" : "Sold out";
        }
      }

      form.addEventListener("change", update);
      update();
    });
  }

  function formatMoney(cents) {
    return "$" + (cents / 100).toFixed(2);
  }

  /* Generative topographic contour field (marching squares) */
  function initTopo() {
    var canvases = document.querySelectorAll("[data-topo]");
    if (!canvases.length || !window.requestAnimationFrame) return;
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    canvases.forEach(function (canvas) {
      var ctx = canvas.getContext("2d");
      if (!ctx) return;
      var color = canvas.getAttribute("data-topo-color") || "#64DC78";
      var alpha = parseFloat(canvas.getAttribute("data-topo-opacity") || "0.5");
      var speed = parseFloat(canvas.getAttribute("data-topo-speed") || "0.25");
      var cell = parseInt(canvas.getAttribute("data-topo-cell") || "34", 10);
      var LEVELS = 11;
      var W, H, dpr, cols, rows, field;

      var peaks = [];
      for (var i = 0; i < 4; i++) {
        peaks.push({ x: Math.random() * 2 - 1, y: Math.random() * 2 - 1, a: 0.6 + Math.random() * 0.9, s: 0.35 + Math.random() * 0.4, dx: Math.random() * 0.4, dy: Math.random() * 0.4 });
      }

      function resize() {
        dpr = Math.min(window.devicePixelRatio || 1, 2);
        var r = canvas.getBoundingClientRect();
        W = Math.max(1, r.width); H = Math.max(1, r.height);
        canvas.width = W * dpr; canvas.height = H * dpr;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        cols = Math.ceil(W / cell) + 2; rows = Math.ceil(H / cell) + 2;
        field = new Float32Array(cols * rows);
      }

      function sample(nx, ny, t) {
        var v = Math.sin(nx * 3.1 + t) * 0.5 + Math.sin(ny * 2.3 - t * 0.8) * 0.5 + Math.sin((nx + ny) * 1.7 + t * 0.6) * 0.4;
        for (var p = 0; p < peaks.length; p++) {
          var pk = peaks[p];
          var ddx = nx - (pk.x + pk.dx * Math.sin(t * 0.3 + p));
          var ddy = ny - (pk.y + pk.dy * Math.cos(t * 0.25 + p));
          v += pk.a * Math.exp(-(ddx * ddx + ddy * ddy) / (2 * pk.s * pk.s));
        }
        return v;
      }

      function edge(x1, y1, v1, x2, y2, v2, lev) {
        var d = (lev - v1) / (v2 - v1);
        return [x1 + (x2 - x1) * d, y1 + (y2 - y1) * d];
      }

      function draw(t) {
        ctx.clearRect(0, 0, W, H);
        var mn = Infinity, mx = -Infinity, j, i, f;
        for (j = 0; j < rows; j++) {
          for (i = 0; i < cols; i++) {
            f = sample((i * cell / W) * 2 - 1, (j * cell / H) * 2 - 1, t);
            field[j * cols + i] = f;
            if (f < mn) mn = f; if (f > mx) mx = f;
          }
        }
        for (var l = 0; l < LEVELS; l++) {
          var lev = mn + (mx - mn) * (l + 0.5) / LEVELS;
          var index = (l % 5 === 0);
          ctx.beginPath();
          for (j = 0; j < rows - 1; j++) {
            for (i = 0; i < cols - 1; i++) {
              var x = i * cell, y = j * cell;
              var tl = field[j * cols + i], tr = field[j * cols + i + 1],
                  br = field[(j + 1) * cols + i + 1], bl = field[(j + 1) * cols + i];
              var id = (tl > lev ? 8 : 0) | (tr > lev ? 4 : 0) | (br > lev ? 2 : 0) | (bl > lev ? 1 : 0);
              if (id === 0 || id === 15) continue;
              var top = function () { return edge(x, y, tl, x + cell, y, tr, lev); };
              var right = function () { return edge(x + cell, y, tr, x + cell, y + cell, br, lev); };
              var bottom = function () { return edge(x + cell, y + cell, br, x, y + cell, bl, lev); };
              var left = function () { return edge(x, y + cell, bl, x, y, tl, lev); };
              var seg;
              switch (id) {
                case 1: seg = [bottom(), left()]; break;
                case 2: seg = [right(), bottom()]; break;
                case 3: seg = [right(), left()]; break;
                case 4: seg = [top(), right()]; break;
                case 5: seg = [top(), left(), right(), bottom()]; break;
                case 6: seg = [top(), bottom()]; break;
                case 7: seg = [top(), left()]; break;
                case 8: seg = [top(), left()]; break;
                case 9: seg = [top(), bottom()]; break;
                case 10: seg = [top(), right(), bottom(), left()]; break;
                case 11: seg = [top(), right()]; break;
                case 12: seg = [right(), left()]; break;
                case 13: seg = [right(), bottom()]; break;
                case 14: seg = [bottom(), left()]; break;
                default: seg = [];
              }
              for (var s = 0; s < seg.length; s += 2) {
                ctx.moveTo(seg[s][0], seg[s][1]);
                ctx.lineTo(seg[s + 1][0], seg[s + 1][1]);
              }
            }
          }
          ctx.strokeStyle = color;
          ctx.globalAlpha = alpha * (index ? 0.6 : 0.28);
          ctx.lineWidth = index ? 1.4 : 0.8;
          ctx.stroke();
        }
        ctx.globalAlpha = 1;
      }

      resize();
      window.addEventListener("resize", function () { clearTimeout(canvas._rt); canvas._rt = setTimeout(function () { resize(); if (reduce) draw(0.7); }, 150); });
      if (reduce) { draw(0.7); return; }
      var start = null;
      (function loop(ts) {
        if (start === null) start = ts;
        draw((ts - start) / 1000 * speed + 0.7);
        requestAnimationFrame(loop);
      })(0);
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initMobileNav();
    initQty();
    initGallery();
    initVariants();
    initTopo();
  });
})();
